import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';

@Component({
  selector: 'fa-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  isPartnerLink: boolean = false;
  partnerLogo: string;

  constructor(
    private loanService: LoanGtmService,
    private route: Router,
    private userIdentity: UserIdentityService,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
  ) { }

  ngOnInit(): void {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }
    }
    this.checkUserLoggedIn();
  }

  getPartnerDetails(partnerUid) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }

  }

  clearDetails(){
    if (this.isPartnerLink) {
      this.route.navigate(['' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate([''])
  }

}
